<template>
  <div class="coupon">
    <div class="tle flex">
      <h2 class="tit-30 fw700 cor-000">我的优惠券</h2>
      <!-- 标签切换 -->
      <el-tabs
        v-model="activeTab"
        class="coupon_tabs"
        @tab-click="handleTabClick"
      >
        <el-tab-pane label="未使用" name="unused"></el-tab-pane>
        <el-tab-pane label="已使用/已过期" name="used"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 优惠券列表 -->
    <div class="coupon-list">
      <div
        class="coupon-card "
        v-for="(coupon, index) in quanlie.keyong"
        :key="index"
        v-if="activeTab == 'unused'"
      >
        <!-- 左侧金额区 -->
        <div slot="header" class="coupon-header">
          <div class="coupon-amount txt-c">
            <p class="amount tit-40 fw700 cor-fff">
              <span class="tit-18">¥</span>{{ coupon.e }}
            </p>
            <p class="condition tit-14 cor-fff">
              满{{ coupon.tiaojian }}元可用
            </p>
          </div>
        </div>
        <!-- 右侧信息区 -->
        <div class="coupon-info">
          <div class="status-tag tit-14">
            {{ coupon.statusText }}
          </div>
          <div>
            <p class="title tit-18 fw700">{{ coupon.biaoti }}</p>
            <p class="valid-time tit-12">
              有效时间：{{ coupon.kaishi }}-{{ coupon.jieshu }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="coupon-card coupon-used"
        v-for="(coupon, index) in quanlie.guoqi"
        :key="index"
        v-if="activeTab == 'used'"
      >
        <!-- 左侧金额区 -->
        <div slot="header" class="coupon-header">
          <div class="coupon-amount txt-c">
            <p class="amount tit-40 fw700 cor-fff">
              <span class="tit-18">¥</span>{{ coupon.e }}
            </p>
            <p class="condition tit-14 cor-fff">
              满{{ coupon.tiaojian }}元可用
            </p>
          </div>
        </div>
        <!-- 右侧信息区 -->
        <div class="coupon-info">
          <div :type="'success'" class="status-tag tit-14">
            {{ coupon.statusText }}
          </div>
          <div>
            <p class="title tit-18 fw700">{{ coupon.biaoti }}</p>
            <p class="valid-time tit-12">
              有效时间：{{ coupon.kaishi }}-{{ coupon.jieshu }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 已过期优惠券 -->
  </div>
</template>

<script>
export default {
  name: "CouponList",
  data() {
    return {
      activeTab: "unused", // 默认选中“未使用”
      coupons: [
        {
          amount: 10000,
          fullCondition: 99000,
          title: "灵犀X1整机组件套餐优惠券",
          startTime: "2025/03/31",
          endTime: "2025/04/30",
          statusText: "可使用",
          tagType: "success",
          used: false, // 标记是否已使用，实际可结合接口状态
        },
        {
          amount: 10000,
          fullCondition: 99000,
          title: "灵犀X1整机组件套餐优惠券",
          startTime: "2025/03/31",
          endTime: "2025/04/30",
          statusText: "可使用",
          tagType: "success",
          used: true, // 标记是否已使用，实际可结合接口状态
        },
        // 可扩展更多优惠券数据...
      ],
      quanlie: [],
    };
  },
  created() {
    this.CSH();
  },
  computed: {
    // filteredCoupons() {
    //   if (this.activeTab === "unused") {
    //     // 未使用：筛选出未过期、未使用的券（可根据实际逻辑调整）
    //     return this.coupons.filter((coupon) => !coupon.used);
    //   } else {
    //     // 已使用/已过期：筛选出已使用或过期的券（可根据实际逻辑调整）
    //     return this.coupons.filter((coupon) => coupon.used);
    //   }
    // },
  },
  methods: {
    CSH() {
      var that = this;
      that.$post("k=quan", function(s) {
        that.quanlie = s.shu;
        // console.log(that.quanlie.shiyong)
        // this.zongshu = Number(s.shu.zongshu);
      });
    },
    handleTabClick(tab) {
      // 可扩展：切换标签时，如需重新请求接口，可在此处调用接口
      this.CSH();
    },
  },
};
</script>

<style lang="less" scoped>
.coupon {
  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.4rem;
    .coupon-card {
      background: #fafafa;
      border-radius: 0.1rem;
      width: 48%;
      margin-bottom: 0.3rem;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      min-height: 1.4rem;
      .coupon-header {
        padding: 0.2rem;
        background: linear-gradient(180deg, #41b9e0 0%, #001ff5 100%);
        height: 100%;
        display: flex;
        align-items: center;
        .amount {
          line-height: 1;
        }
      }

      .coupon-info {
        position: relative;
        height: 100%;
        padding: 0.4rem 0.2rem;
        display: flex;
        align-items: center;
        overflow: hidden;
        flex: 1;
        .status-tag {
          position: absolute;
          right: 0;
          top: 0;
          background: rgba(181, 230, 251, 0.5);
          border-radius: 0rem 0.15rem 0 0.15rem;
          color: #0e6efd;
          padding: 0.04rem 0.1rem;
        }

        .valid-time {
          margin-top: 0.1rem;
          color: #a9a9a9;
        }
      }
    }

    // 过期/已使用优惠券
    .coupon-used {
      opacity: 0.5;
    }
  }
}

/* el-tabs */
/deep/ .coupon_tabs {
  margin-left: 0.4rem;

  .el-tabs__active-bar {
    background-color: #0e6efd;
  }
  .el-tabs__item {
    font-size: var(--font16);
    color: #9d9d9d;
    &:hover {
      color: #0e6efd;
    }

    &.is-active {
      color: #0e6efd;
    }
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  .coupon {
    .tle {
      flex-wrap: wrap;

      .coupon_tabs {
        width: 100%;
        margin-left: 0;
      }
    }

    .coupon-list .coupon-card {
      width: 100%;
    }
  }
}
</style>
